import { CONTENT_MIGRATION_FETCH_STATUS_SUCCESS } from '../actions/fetch-status';
import { CONTENT_MIGRATION_ROLLBACK_SUCCESS } from '../actions/rollback';
import { CONTENT_MIGRATION_SET_REDIRECTS_SUCCESS } from '../actions/set-redirects';
import { MIGRATION_STATUS_NOT_STARTED } from '../constants/migration-status';

export const INITIAL_STATE = {
  status: MIGRATION_STATUS_NOT_STARTED,
};

export default function contentMigration(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONTENT_MIGRATION_ROLLBACK_SUCCESS:
    case CONTENT_MIGRATION_FETCH_STATUS_SUCCESS:
    case CONTENT_MIGRATION_SET_REDIRECTS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
